import { container } from '@databases/service-container';
import { useCallback, useEffect } from 'react';

import { isEmptyClipboard } from '../helpers/is-empty-clipboard';

// It's empty ATM but leaving this in case Databases wants to implement cut
// functionality (needs to pass in props)
// eslint-disable-next-line @typescript-eslint/no-empty-object-type
interface UseCutDatabaseContentProps {}

type CutHandler = (event: ClipboardEvent) => void;

/**
 * Registers a document event listener that reacts to cut events.
 * This is used to cut the selected database content to the clipboard.
 */
export const useCutListener = (_: UseCutDatabaseContentProps) => {
  const cutListener: CutHandler = useCallback((e) => {
    if (!isEmptyClipboard(e)) {
      // Still gotta make sure that if there's any data in the payload, we let
      // the browser decide what to do - We only want to handle empty payloads
      return;
    }

    const eventBus = container.resolve('EventBus');
    eventBus.dispatch('forwardCutClipboardToParent', null);
  }, []);

  useEffect(() => {
    document.addEventListener('cut', cutListener);

    return () => {
      document.removeEventListener('cut', cutListener);
    };
  }, [cutListener]);
};
